export default __webpack_public_path__ + "static/media/plate_sura.b5c56389.svg";